import React, { useState, useEffect } from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { isNewVersionAvailable } from '../shared/utils.js';

export default function VersionRefreshIcon() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    // Check on mount
    const checkVersion = () => {
      setShow(isNewVersionAvailable());
    };
    
    checkVersion();
    
    // Listen for custom event when tabs change
    window.addEventListener('checkVersion', checkVersion);
    
    return () => {
      window.removeEventListener('checkVersion', checkVersion);
    };
  }, []);

  const handleRefresh = () => {
    window.location.reload();
  };

  if (!show) {
    return null;
  }

  const tooltip = (
    <Tooltip id="version-refresh-tooltip">
      A new version exists, click here to refresh
    </Tooltip>
  );

  return (
    <OverlayTrigger placement="bottom" overlay={tooltip}>
      <button
        onClick={handleRefresh}
        className="version-refresh-icon"
        aria-label="Refresh page for new version"
      >
        <i className="bi bi-arrow-clockwise"></i>
      </button>
    </OverlayTrigger>
  );
}
